'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoAndroidBicycle = function IoAndroidBicycle(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm23.4 10.2c-1.5 0-2.7-1.1-2.7-2.5s1.2-2.7 2.7-2.7 2.5 1.2 2.5 2.7-1.1 2.5-2.5 2.5z m4.3 10.2c4 0 7.3 3.4 7.3 7.3s-3.3 7.3-7.3 7.3-7.3-3.3-7.3-7.3 3.4-7.3 7.3-7.3z m0 12.4c2.8 0 5.1-2.3 5.1-5.1s-2.3-5.1-5.1-5.1-5.1 2.3-5.1 5.1 2.3 5.1 5.1 5.1z m-6.3-15.3l-2.3-3.5-3.4 3.5 3.1 2.5v8.8h-2.5v-6.8l-4.8-2.9c-0.7-0.5-1.5-1.2-1.5-2.1 0-0.7 0.2-1.4 0.7-1.8l5.6-5.4c0.5-0.5 1.1-0.7 1.7-0.7 0.9 0 1.8 0.5 2.2 1.2l2.7 4.7h4.6v2.5h-6.1z m-14.1 2.9c3.9 0 7.3 3.4 7.3 7.3s-3.3 7.3-7.3 7.3-7.3-3.3-7.3-7.3 3.3-7.3 7.3-7.3z m0 12.4c2.8 0 5.1-2.3 5.1-5.1s-2.3-5.1-5.1-5.1-5.1 2.3-5.1 5.1 2.3 5.1 5.1 5.1z' })
        )
    );
};

exports.default = IoAndroidBicycle;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/android-bicycle.js
// module id = 2303
// module chunks = 168707334958949